/**
 * @generated SignedSource<<a12c1f45f7c28f4940210270ff0147ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type LimitedCartDiscountConditionKindEnum = "ProductSelection";
import { FragmentRefs } from "relay-runtime";
export type limitedCartDiscountForm_LimitedCartDiscountFragment$data = {
  readonly conditions: ReadonlyArray<{
    readonly amount?: number;
    readonly id?: string;
    readonly kind: LimitedCartDiscountConditionKindEnum;
    readonly product?: {
      readonly title: string;
    } | null;
    readonly productId?: string;
    readonly " $fragmentSpreads": FragmentRefs<"limitedCartDiscountForm_ProductSelectionConditionFragment">;
  }>;
  readonly id: string;
  readonly isReductible: boolean;
  readonly productSelectionConfig: {
    readonly value?: number;
  };
  readonly title: string;
  readonly " $fragmentType": "limitedCartDiscountForm_LimitedCartDiscountFragment";
};
export type limitedCartDiscountForm_LimitedCartDiscountFragment$key = {
  readonly " $data"?: limitedCartDiscountForm_LimitedCartDiscountFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"limitedCartDiscountForm_LimitedCartDiscountFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "product",
  "plural": false,
  "selections": [
    (v1/*: any*/)
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "limitedCartDiscountForm_LimitedCartDiscountFragment",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isReductible",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "conditions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "kind",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v2/*: any*/),
            (v0/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            {
              "kind": "InlineDataFragmentSpread",
              "name": "limitedCartDiscountForm_ProductSelectionConditionFragment",
              "selections": [
                (v0/*: any*/),
                (v3/*: any*/),
                (v4/*: any*/),
                (v2/*: any*/)
              ],
              "args": null,
              "argumentDefinitions": []
            }
          ],
          "type": "ProductSelectionCondition",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "productSelectionConfig",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "type": "PercentageProductSelectionConfig",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LimitedCartDiscount",
  "abstractKey": null
};
})();

(node as any).hash = "8a6742ec2ffd8aba81d4e79915ef12d5";

export default node;
